import styled, { CSSProperties } from "styled-components";
import { ExternalLink } from "../links/ExternalLink";

export const StyledTemplate = styled.div<{
  $display?: CSSProperties["display"];
}>`
  display: ${(props) => props.$display ?? "inline-block"};
`;

export const StyledExternalLink = styled(ExternalLink)<{
  removeLinkColor?: boolean;
}>`
  ${({ theme, removeLinkColor }) =>
    !removeLinkColor && `color: ${theme.color.primary}`};
`;
